require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-chinese-guidelines.json") })
        }
      }, "path---en-us-project-chinese-guidelines");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-chinese-guidelines!./.cache/json/en-us-project-chinese-guidelines.json
// module id = 498
// module chunks = 231608221292675